import { httpRequest } from "../../http";

export interface DuplicateAdPayload {
    name?: string;
    is_template?: boolean;
    is_default?: boolean;
}

export class CommandDuplicateAd {
    async run(adId: number, payload?: DuplicateAdPayload) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/duplicate/`;
        try {
            const response = await httpRequest<any>(url, {
                method: "POST",
                body: payload ? JSON.stringify(payload) : undefined,
            });
            if (response) {
                return response;
            }
        } catch (error) {
            console.error('Error duplicating ad:', error);
            throw error;
        }
    }
}
